var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-detail',{attrs:{"type":"retail_order_detail","order-number":_vm.orderNumber}})
}
var staticRenderFns = []

export { render, staticRenderFns }